import styled from 'styled-components';
import tw from 'twin.macro';
import { motion } from 'framer-motion';

export const PopoverContainer = styled(motion.div)(() => [
  tw`flex flex-col`,
  'position: absolute;',
  'min-height: 100%;',
  'min-width: 100%;',
  'max-width: 100%;', // Necessary property to have overflow-wrap: break-word to work in the page
  'z-index: 200000;'
]);
